<dashboard-dialog-frame class="advisor-prompt-dialog" [header]="'Prompt Details'" [actions]="actions" [dialogRef]="dialogRef">
	@if(dialogData(); as data){
	<kendo-tabstrip class="h-100 px-2 pt-2">

		<kendo-tabstrip-tab title="Details" [selected]="true">
			<ng-template kendoTabContent>
				<h5 class="mb-0">Prompt</h5>
				<div>{{data.prompt}}</div>

				<h5 class="mt-3 mb-0">Response</h5>
				<markdown [data]="data.responseDetails?.response"></markdown>
			</ng-template>
		</kendo-tabstrip-tab>

		<kendo-tabstrip-tab [title]="data.responseDetails ? 'Response Details' : 'Error'">
			<ng-template kendoTabContent>
				<advisor-prompt-response-or-error-part [dialogData]="data"></advisor-prompt-response-or-error-part>
			</ng-template>
		</kendo-tabstrip-tab>

		<kendo-tabstrip-tab title="Running Summary">
			<ng-template kendoTabContent>
				<markdown [data]="data.responseDetails?.runningSummary"></markdown>
			</ng-template>
		</kendo-tabstrip-tab>

	</kendo-tabstrip>
	}

</dashboard-dialog-frame>